export default function PublishedPostIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_7)">
        <path
          d="M13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7Z"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <circle cx="7" cy="7" r="3.5" fill="currentColor" />
      </g>
    </svg>
  );
}
